import { LoadableLazy } from '@confluence/loadable';
export { isEligibleForFeedbackAnalysisDiscovery } from '../src/rovo/FeedbackAnalysisDialog';
export const LazyFeedbackAnalysisDiscoveryDialog = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-FeedbackAnalysisDiscoveryDialog" */ '../src/rovo/FeedbackAnalysisDialog'
			)
		).FeedbackAnalysisDialog,
});
